import React from "react";
import { Link, useLocation } from "react-router-dom";

import "./RenderDownloadUnavailable.css";

const EXPIRED_COPY = {
  title: "Your render has expired",
  message:
    "Render files are available for five days after completion. Your project is still saved, so you can open it and create a new render.",
};

const INVALID_COPY = {
  title: "Link unavailable",
  message: "This download link is invalid or no longer available.",
};

export default function RenderDownloadUnavailable() {
  const location = useLocation();
  const reason = new URLSearchParams(location.search).get("reason");
  const copy =
    reason === "invalid" || reason === "unavailable" ? INVALID_COPY : EXPIRED_COPY;

  return (
    <main className="render-download-unavailable">
      <section className="render-download-unavailable__card">
        <Link
          className="render-download-unavailable__brand"
          to="/"
          aria-label="ScrollX home"
        >
          ScrollX
        </Link>
        <div
          className="render-download-unavailable__icon"
          aria-hidden="true"
        >
          <span>!</span>
        </div>
        <p className="render-download-unavailable__eyebrow">
          Render download
        </p>
        <h1>{copy.title}</h1>
        <p className="render-download-unavailable__message">{copy.message}</p>
        <div className="render-download-unavailable__actions">
          <Link
            className="render-download-unavailable__button"
            to="/dashboard/myrenders"
          >
            View Render History
          </Link>
          <Link
            className="render-download-unavailable__button render-download-unavailable__button--secondary"
            to="/dashboard"
          >
            Back to Dashboard
          </Link>
        </div>
        <p className="render-download-unavailable__help">
          Need help? <Link to="/contactus">Contact us</Link>
        </p>
      </section>
    </main>
  );
}
